export default __webpack_public_path__ + "static/benefitSection1Bg-598ec12ccc32ce79895c550942d6a9f9.png";